(function () {
    var STORAGE_KEY = 'casper-dev-theme';

    function getStoredTheme() {
        try {
            return localStorage.getItem(STORAGE_KEY);
        } catch (err) {
            return null;
        }
    }

    function setStoredTheme(theme) {
        try {
            localStorage.setItem(STORAGE_KEY, theme);
        } catch (err) {
            /* ignore */
        }
    }

    function getDefaultTheme() {
        return document.documentElement.getAttribute('data-default-theme') || 'light';
    }

    function getEffectiveTheme() {
        var html = document.documentElement;

        if (html.classList.contains('dark-mode')) {
            return 'dark';
        }

        if (html.classList.contains('auto-color')) {
            return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        }

        return 'light';
    }

    function applyTheme(theme) {
        var html = document.documentElement;
        html.classList.remove('dark-mode', 'auto-color');
        html.removeAttribute('data-theme');

        if (theme === 'dark') {
            html.classList.add('dark-mode');
            html.setAttribute('data-theme', 'dark');
            html.style.colorScheme = 'dark';
        } else if (theme === 'auto') {
            html.classList.add('auto-color');
            html.setAttribute('data-theme', 'auto');
            html.style.colorScheme = 'light dark';
        } else {
            html.setAttribute('data-theme', 'light');
            html.style.colorScheme = 'light';
        }

        document.querySelectorAll('[data-theme-toggle]').forEach(function (button) {
            var isDark = getEffectiveTheme() === 'dark';
            button.setAttribute('aria-pressed', isDark ? 'true' : 'false');
        });

        document.dispatchEvent(new CustomEvent('casper-dev-theme-change', {
            detail: { theme: theme }
        }));
    }

    function toggleTheme() {
        var isDark = getEffectiveTheme() === 'dark';
        var nextTheme = isDark ? 'light' : 'dark';
        applyTheme(nextTheme);
        setStoredTheme(nextTheme);
    }

    function initTheme() {
        var stored = getStoredTheme();
        applyTheme(stored || getDefaultTheme());
    }

    function bindToggle() {
        document.addEventListener('click', function (event) {
            var button = event.target.closest('[data-theme-toggle]');
            if (!button) {
                return;
            }
            event.preventDefault();
            toggleTheme();
        });
    }

    initTheme();
    bindToggle();
})();
